// This utility helps handle navigation outside of React components
let navigator = null;

export const setNavigator = (nav) => {
	navigator = nav;
};

export const navigate = (to, options) => {
	if (navigator) {
		navigator(to, options);
	} else {
		window.location.href = to;
	}
};
